import { render, staticRenderFns } from "./yysd-table.vue?vue&type=template&id=7676248b&scoped=true"
import script from "./yysd-table.vue?vue&type=script&lang=js"
export * from "./yysd-table.vue?vue&type=script&lang=js"
import style0 from "./yysd-table.vue?vue&type=style&index=0&id=7676248b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7676248b",
  null
  
)

export default component.exports